import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import BootstrapVue from 'bootstrap-vue'

import firebase from 'firebase/app'
import 'firebase/performance'

firebase.initializeApp({
  apiKey: "AIzaSyDX4QDRmkakqewQ-Bc07cJCP_py1SSbWi8",
  authDomain: "tkpetersen-web.firebaseapp.com",
  databaseURL: "https://tkpetersen-web.firebaseio.com",
  projectId: "tkpetersen-web",
  storageBucket: "",
  messagingSenderId: "57006444255",
  appId: "1:57006444255:web:41d6607f672b2c1f"
})

export const perf = firebase.performance();

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
